export function getLangParam() {
  try {
    const params = new URLSearchParams(window.location.search);
    return (params.get('lang') || '').toLowerCase().trim();
  } catch (e) {
    return '';
  }
}

function getSavedLang() {
  try {
    const a = (localStorage.getItem('bmn_preferred_lang') || '').toLowerCase().trim();
    if (a === 'en' || a === 'de' || a === 'pl') return a;
    const b = (localStorage.getItem('ryp_lang') || '').toLowerCase().trim();
    if (b === 'en' || b === 'de' || b === 'pl') return b;
  } catch (e) {
    // Ignore storage access issues.
  }
  return '';
}

export function getCurrentLangCode() {
  const lang = getLangParam();
  if (lang.startsWith('en')) return 'en';
  if (lang.startsWith('pl')) return 'pl';
  if (lang.startsWith('de')) return 'de';
  const saved = getSavedLang();
  if (saved === 'en' || saved === 'pl' || saved === 'de') return saved;
  return 'de';
}

/**
 * Default behavior for this project:
 * - German is the default when no explicit language is set.
 * - Use `?lang=en` to force English.
 * - Use `?lang=de` to force German.
 * - Use `?lang=pl` to force Polish.
 */
export function computeIsGermanDefault() {
  return getCurrentLangCode() === 'de';
}

